import { useNavigate } from 'react-router-dom';
import type { ModuleEntry } from '@/lib/module-registry';
import LucideIcon from '@/components/LucideIcon';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '@/components/ui/card';

interface ModuleTileProps {
  module: ModuleEntry;
}

/**
 * Dashboard tile for a single module.
 * Shows name, description, icon, and a launch button that navigates
 * to the module's route within the shell.
 */
export default function ModuleTile({ module }: ModuleTileProps) {
  const navigate = useNavigate();

  return (
    <Card className="flex flex-col">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div
            className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted"
            aria-hidden="true"
          >
            <LucideIcon name={module.icon} className="size-5" />
          </div>
          <CardTitle>{module.name}</CardTitle>
        </div>
        <CardDescription>{module.description}</CardDescription>
      </CardHeader>
      <CardContent className="mt-auto">
        <Button
          className="w-full"
          onClick={() => void navigate(module.routePath)}
        >
          Launch
        </Button>
      </CardContent>
    </Card>
  );
}
